//@flow
import React from 'react';
import type { RouterHistory, Match, Location } from 'react-router-dom';
import { observer, inject } from 'mobx-react';
import AuthenticatedRouteContainer from './AuthenticatedRouteContainer';
import ReactGA from 'react-ga';
import { gaId } from '../config';
import Loading from '../components/core/Loading';
import Api from '../api';
import Cookies from 'universal-cookie';

type Props = {
  userStore: any,
  languageStore: any,
  history: RouterHistory,
  location: Location,
  match: Match
}

class App extends React.Component<Props> {
  unsubscribeFromHistory: any;

  componentWillMount() {
    const { userStore, languageStore } = this.props;
    languageStore.fetchSupportedLanguages().then(() => {
      const cookies = new Cookies();
      const langCode = cookies.get('langCode') || 'en';

      languageStore.setLanguage(langCode);
      userStore.fetchUserProfile();
    });

    this.unsubscribeFromHistory = this.props.history.listen(() => {
      // Keep alive on any further route changes
      Api.keepAlive();
    });
  }

  componentWillUnmount() {
    if (this.unsubscribeFromHistory) {
      this.unsubscribeFromHistory();
    }
  }

  renderLoadingDuringUserProfileFetch() {
    return (
      <Loading />
    );
  }

  renderAuthenticatedRoute() {
    const { match, history, location } = this.props;
    const { userStore } = this.props;

    if (gaId && userStore.user) {
      ReactGA.initialize(gaId, {
        gaOptions: {
          userId: userStore.user.username
        }
      });
    }

    return (
      <div>
        <AuthenticatedRouteContainer
          history={history}
          match={match}
          location={location}
        />
      </div>
    );
  }

  renderPage() {
    const { userStore, languageStore } = this.props;
    const { isFetchingLang } = languageStore;
    const { isFetchingUserProfile } = userStore;

    return (isFetchingLang || isFetchingUserProfile) ?
      this.renderLoadingDuringUserProfileFetch() :
      this.renderAuthenticatedRoute();
  }

  render() {
    return this.renderPage();
  }
}

export default inject('userStore', 'languageStore')(observer(App));



// WEBPACK FOOTER //
// ./src/containers/App.js